module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/blog-components/create-blog-category/create-blog-category.component.css
// module id = ./src/app/blog-components/create-blog-category/create-blog-category.component.css
// module chunks = main